import { Component, OnInit, Input } from '@angular/core';
import { Event } from '../../interfaces';

@Component({
	selector: 'eze-registration-page-postcard',
	templateUrl: './registration-page-postcard.component.html',
	styleUrls: ['./registration-page-postcard.component.css']
})
export class RegistrationPagePostcardComponent implements OnInit {
	@Input() eventDetails: Event = null;

	constructor() {}

	ngOnInit() {}
}
